/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'
import { organisationRelationDataAccessModeSchema } from './OrganisationRelationDataAccessModeSchema'

export const organisationRelationDataSchema: z.ZodType = z.object({
	entitlements: z.array(
		z.union([
			z.literal('jobilla-meet'),
			z.literal('fully-serviced'),
			z.literal('addon-ats-integration'),
			z.literal('addon-custom-templates'),
			z.literal('addon-custom-invoicing-config'),
			z.literal('addon-whatsapp'),
		]),
	).nullable(),
	accessMode: organisationRelationDataAccessModeSchema.nullable(),
	parent: z.lazy(() => organisationRelationDataSchema).nullable().optional(),
	children: z.array(z.lazy(() => organisationRelationDataSchema)).optional(),
	id: z.string(),
	name: z.string(),
	slug: z.string(),
	meta: z.record(z.string(), z.unknown()).nullable(),
	workosId: z.string().nullable(),
	updatedAt: z.iso.datetime(),
	careerSiteEnabled: z.boolean().default(false),
	candidateProfileEnabled: z.boolean().default(true),
	candidateProfileCvCollectionEnabled: z.boolean().default(true),
	membershipStatus: z.string().nullable(),
	membershipId: z.string().nullable(),
	isDemo: z.boolean().default(false),
	hasParent: z.boolean().nullable(),
	hasChildren: z.boolean().nullable(),
	isSalesDriven: z.boolean().nullable(),
})

export type OrganisationRelationDataSchema = z.infer<typeof organisationRelationDataSchema>
